
//TO-DO: Passar estes métodos para a model-sagres
export class FiltrosLegislacao {
    exercicio: string
    tipoDeEntrega: string

    constructor() {
        this.exercicio = ''
        this.tipoDeEntrega = ''

    }

    limpar(): void {
        this.exercicio = ''
        this.tipoDeEntrega = ''

    }

    toQueryString(): string {
        let retorno = ''
        if (this.exercicio)
            retorno += '&exercicio=' + this.exercicio
        if (this.tipoDeEntrega)
            retorno += '&tipoEntrega=' + this.tipoDeEntrega
        return retorno
    }
}